import { Outlet } from 'react-router-dom'

export default function AppLayout() {
  return (
    <div className="w-screen h-screen overflow-hidden relative">
      <Outlet />
    </div>
  )
}
